
import * as React from 'react';
import {observer} from 'mobx-react-lite';
import styled from '@emotion/styled';
import {mainColors} from '../colors';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const MinusCircleIcon = observer(( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper width={20} height={20} className={className} fill={mainColors.default.light} viewBox='0 0 20 20'>
        <g fill='#000' fillRule='nonzero'>
            <g>
                <g>
                    <g>
                        <path d='M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm4.375 10.833h-8.75c-.46 0-.833-.373-.833-.833 0-.46.373-.833.833-.833h8.75c.46 0 .833.373.833.833 0 .46-.373.833-.833.833z' transform='translate(-852 -377) translate(554 247) translate(0 120) translate(298 10)'/>
                    </g>
                </g>
            </g>
        </g>
    </SvgWrapper>

));
